export const getBase64ImageSrc = (url: string) =>
  `data:image/png;base64,${url}`;

export const isValidPhone = (value: string): boolean => {
  return /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(value);
};

export const isValidEmail = (email: string): boolean => {
  let valid = false;

  if (email && /^[A-Z0-9._%'+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
    valid = true;
  }

  return valid;
};

export const isValidHttpsUrl = (path: string): boolean => {
  return /^https?:\/\//.test(path);
};

export const getCompanyName = () => {
  const companyName = window.location.pathname.split('/')[1];
  const hasSpecialChar = /[^a-zA-Z0-9_-]/.test(companyName);
  if (hasSpecialChar) {
    // If the company name has special characters, redirect to 404 page
    window.location.replace('/');
    return '';
  }
  return companyName;
};

export const redirectToOrg = (orgUrl: string) =>
  window.location.replace(orgUrl);

export const isInStandaloneMode = () => Boolean(window.navigator.standalone);

export const queryKeyGenerator = (key: string, planYearId?: number) => {
  return planYearId && planYearId > 0 ? `${key}-${planYearId}` : key;
};
